import { SignupSteps } from 'routes/Signup/constants/SignupSteps'

import fourPersonBoxImg from 'media/images/box-prices/four-person-box.jpg'
import twoPersonBoxImg from 'media/images/box-prices/two-person-box.jpg'

import fourPortionsPng from './assets/four-recipe-portions.png'
import fourPortionsWebp from './assets/four-recipe-portions.webp'
import twoPortionsPng from './assets/two-recipe-portions.png'
import twoPortionsWebp from './assets/two-recipe-portions.webp'

export const PaymentMethod = {
  Card: 'Card',
  PayPal: 'PayPal',
  ApplePay: 'ApplePay',
  Bento: 'Bento',
}

const checkAccountPageSlug = 'start'
const applyVoucherPageSlug = 'apply-voucher'
const enterPromoCodeManuallyPageSlug = 'enter-discount-code'
const postcodeSlug = 'postcode'
const boxPriceSlug = 'box-size'

export const signupConfig = {
  /**
   * If experiment steps should be added:
   * 1. Create another entry in signupConfig with listing appropriate steps (similar to signupConfig.defaultSteps).
   * 2. Add entries of new steps into signupConfig.steps array.
   * 3. Refer to new steps variable in "getSignupSteps.ts" file.
   * 4. Map step to component in "AvailableStepComponents.ts" file.
   */
  defaultSteps: [SignupSteps.BOX_SIZE, SignupSteps.POSTCODE, SignupSteps.DELIVERY],
  stepsWithPortionSizes: [
    SignupSteps.BOX_SIZE_WITH_RADIO,
    SignupSteps.POSTCODE,
    SignupSteps.DELIVERY,
  ],
  steps: [
    { name: SignupSteps.BOX_SIZE, slug: 'box-size' },
    { name: SignupSteps.BOX_SIZE_WITH_RADIO, slug: 'box-size' },
    { name: SignupSteps.POSTCODE, slug: 'postcode' },
    { name: SignupSteps.DELIVERY, slug: 'delivery-options' },
  ],
  payment_types: {
    card: 'card',
    paypal: 'paypal',
  },
  address_types: {
    billing: 'billing',
    shipping: 'shipping',
  },
  boxSizeStep: {
    title: 'Choose your box size',
    portionClarityTitle: 'Which box size would you like to start with?',
    cta: 'Select',
    boxSize: {
      2: {
        description:
          'This smaller box is packed with enough pre-measured ingredients for each recipe to feed 2 people.',
        image: twoPersonBoxImg,
      },
      4: {
        description:
          'This larger box is packed with enough pre-measured ingredients for each recipe to feed 4 people.',
        image: fourPersonBoxImg,
      },
    },
    discountApplied: 'Discount applied',
    boxSizeTypes: [
      {
        heading: 'Regular box',
        recipeInfoTextStart: 'You can choose from ',
        recipeInfoStrongText: '2 to 5',
        recipeInfoTextEnd: ' recipes per box.',
        suitableFor: ['2 adults (or 1 + leftovers)', '1 adult and 1-2 children'],
        ctaText: 'Choose regular box',
        value: 2,
      },
      {
        heading: 'Large box',
        recipeInfoTextStart: 'You can choose from ',
        recipeInfoStrongText: '2 to 4',
        recipeInfoTextEnd: ' recipes per box.',
        suitableFor: ['4 adults (or 2-3 + leftovers)', '2 adults and 2-3 children'],
        ctaText: 'Choose large box',
        value: 4,
      },
    ],
    portionClairtyBoxSizeTypes: [
      {
        heading: 'Regular box',
        suitableFor: ['2 adults', '1 adult and leftovers', '1 adult and 1 or 2 children'],
        ctaText: 'Choose regular box',
        value: 2,
        pngImage: twoPortionsPng,
        webpImage: twoPortionsWebp,
      },
      {
        heading: 'Large box',
        suitableFor: ['4 adults', '2 or 3 adults and leftovers', '2 adults and 2 or 3 children'],
        ctaText: 'Choose large box',
        value: 4,
        pngImage: fourPortionsPng,
        webpImage: fourPortionsWebp,
      },
    ],
  },
  boxSizePriceBreakdownStep: {
    boxSizeTypes: [
      {
        heading: 'Regular box',
        subHeading: '2 generous portions per chosen recipe',
        ctaText: 'Choose regular box',
        value: 2,
      },
      {
        heading: 'Large box',
        subHeading: '4 generous portions per chosen recipe',
        ctaText: 'Choose large box',
        value: 4,
      },
    ],
    accordionTitle: 'price breakdown',
    pricePlaceholder: '£--.--',
    wasPricePlaceholder: 'Was £--.--',
    boxInfoTextStart: 'From',
    boxInfoTextEnd: 'per box',
  },
  postCodeStep: {
    title: 'Where would you like your boxes delivered?',
    goustoOnDemandTitle: 'Where would you like your box delivered?',
    reminder: 'Delivered to your door, 7 days a week',
    doNotDeliverErrorMessage: 'Sorry, it looks like we don’t currently deliver to your area.',
    genericErrorMessage: 'Please enter a valid postcode',
  },
  deliveryOptionsStep: {
    title: 'When would you like your first box delivered?',
    goustoOnDemandTitle: 'When do you want your box delivered?',
  },
  discountAppliedText: 'View this when you reach the checkout.',
  sellThePropositionPageSlug: 'about',
  checkAccountPageSlug,
  applyVoucherPageSlug,
  enterPromoCodeManuallyPageSlug,
  canLandOnStepWithoutRedirecting: [
    checkAccountPageSlug,
    applyVoucherPageSlug,
    enterPromoCodeManuallyPageSlug,
    /**
     * Required for redirected to postcode from box prices.
     */
    postcodeSlug,
    boxPriceSlug,
  ],
}
